import { render } from "./AccessControl.vue?vue&type=template&id=0e84829a&scoped=true"
import script from "./AccessControl.vue?vue&type=script&lang=js"
export * from "./AccessControl.vue?vue&type=script&lang=js"

import "./AccessControl.vue?vue&type=style&index=0&id=0e84829a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e84829a"]])

export default __exports__